module.exports = __webpack_public_path__ + "images/208addd.png";